import { useLang } from './lang';
import { LANG_ORDER, LANGS } from './strings';

/*
 * A PLAIN SELECT for the reader's language. Native, so the keyboard and a screen reader get it for
 * free; labelled by `t('lang.label')` so the label itself is in the chosen language. Each option is
 * an endonym — a speaker of a language recognises its own name, not its English exonym.
 */
export function LanguageSwitcher(): React.JSX.Element {
  const { lang, setLang, t } = useLang();
  return (
    <label className="lang-switcher">
      <span className="lang-switcher-label">{t('lang.label')}</span>
      <select
        aria-label={t('lang.label')}
        value={lang}
        onChange={(event) => {
          const next = LANG_ORDER.find((code) => code === event.target.value);
          if (next) setLang(next);
        }}
      >
        {LANG_ORDER.map((code) => (
          <option key={code} value={code} lang={code}>{LANGS[code].label}</option>
        ))}
      </select>
    </label>
  );
}
